export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const featuredTestimonials: Testimonial[] = [
  {
    initials: 'JM',
    name: 'J.M.',
    role: 'Ninja Coach — Madrid, Spain',
    text: 'I no longer spend my Sunday nights building classes from scratch. I open the system, choose the class, and walk in completely prepared. My athletes feel the difference — and so do I.',
  },
  {
    initials: 'RC',
    name: 'R.C.',
    role: 'Ninja Instructor — Mexico City, Mexico',
    text: 'The emergency classes alone saved me three times in the first month. That bonus is worth the full price by itself.',
  },
  {
    initials: 'LS',
    name: 'L.S.',
    role: 'Obstacle Course Coach — São Paulo, Brazil',
    text: 'The coaching cues library completely changed how I train. My transitions feel smoother, my language is clearer, and my athletes stay focused from warmup to final challenge.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'MV',
    name: 'M.V.',
    role: 'Ninja Coach | Barcelona, Spain',
    text: 'The obstacle technique classes completely changed how my athletes learn. The progressions are already written — I just coach them. My classes feel more professional than ever.',
  },
  {
    initials: 'TG',
    name: 'T.G.',
    role: 'Ninja Instructor | Monterrey, Mexico',
    text: "The emergency classes saved me more times than I can count in my first month. Before, I'd get nervous when my plan fell apart. Now I just open the backup library and we train.",
  },
  {
    initials: 'FC',
    name: 'F.C.',
    role: 'Obstacle Course Coach | Bogotá, Colombia',
    text: 'I review the key cues before every session and walk in knowing exactly what to say. The cues library is something I use every week.',
  },
  {
    initials: 'AR',
    name: 'A.R.',
    role: 'Ninja Coach | Lima, Peru',
    text: 'The adaptation guide gave me confidence back with mixed-ability groups. Before, I was always nervous when a new athlete with different needs arrived. Now I have the right progression ready before class even starts.',
  },
  {
    initials: 'SL',
    name: 'S.L.',
    role: 'Ninja Coach | Medellín, Colombia',
    text: 'The weekly themes were a complete game-changer. My athletes talk about those sessions for weeks. They feel like a real experience, not just a workout.',
  },
]
